import { VStack } from '@chakra-ui/react';
import type { Dispatch, SetStateAction, FunctionComponent, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { AutoReloadToggle } from '../../AutoReloadToggle';
import { SelectedIccidsAccordion } from 'components';
import { type Sim, ShopProductSku } from 'utils/graphql/hooks';
import { useShopCheckoutContext } from 'utils/provider/ShopCheckoutProvider';

interface AutoReloadModalContentProps {
  simCards: Sim[];
  inputRef: RefObject<HTMLInputElement>;
  onClose: () => void;
  setRedirectUrl: Dispatch<SetStateAction<string | undefined>>;
}

export const AutoReloadModalContent: FunctionComponent<AutoReloadModalContentProps> = ({
  simCards,
  inputRef,
  onClose,
  setRedirectUrl,
}) => {
  const { t } = useTranslation();
  const { prefetchShopCheckoutPageData } = useShopCheckoutContext();

  prefetchShopCheckoutPageData(ShopProductSku.Datavolume_1gb);

  return (
    <VStack spacing={4}>
      <SelectedIccidsAccordion
        pt="4"
        iccids={simCards.map((c) => c.iccid)}
        accordionButtonContent={t('sim.bulk.showIccids', { count: simCards.length })}
      />

      <AutoReloadToggle simCards={simCards} setRedirectUrl={setRedirectUrl} />
    </VStack>
  );
};
